module.exports = __webpack_public_path__ + "static/media/img9.18d9cd43.jpg";